export default __webpack_public_path__ + "static/media/background-new-brand.489f00f9.svg";